import intsql from "../images/Intermediate SQL.png";
import indiaboxoffice from "../images/India Box office.png";
import sqlbasic from "../images/Sql basic.png";
import introtosql from "../images/Intro to Sql.png";
import introtopowerbi from "../images/Intro to power bi.png";
import cisco from "../images/Cisco.png";
import powerbiservice from "../images/Power BI Service.png";
import thinkinglikeananalyst from "../images/Thinking like an analyst.png";
import dataandaiethics from "../images/Data & AI Ethics.png";
import top5 from "../images/Top 5.png";
import top5_2 from "../images/Top 5 2.png";
import storyteller from "../images/storyteller badge.jpeg";
import sqlint from "../images/sql intermediate.png";
import python from "../images/python.png";
import mysql from "../images/sqlmaven.png";
import pythonsummer from "../images/pythonsummer cert.png";
import top5_3 from "../images/top5_3.png";
import cloud_basics from "../images/cloud_basics.png";
import fin_model from "../images/fin_model.png";
import sql_advent_2 from "../images/sql_advent_2.png";
import data_literacy from "../images/Data Literacy Foundation.png";
import critical_thinking from "../images/Critical thinking.png";
import gen_ai from "../images/gen ai.png";
import prompt_eng from "../images/prompt eng.png";
import associate_da from "../images/Associate DA.png";
import runner_up from "../images/runner up awards.png";
import top_performer from "../images/Emmanuel Idowu award.png";
import advanced_sql from "../images/Advanced SQL Querying.png";
import honourablemention from "../images/Honorable Mention 1.jpg";

const AwardDB = [
  {
    id: "M534j200",
    title: "Honourable Mention",
    pic: honourablemention,
    view: "",
  },
  {
    id: "M534j200",
    title: "Associate Data Analyst",
    pic: associate_da,
    view: "",
  },
  {
    id: "ADVj200",
    title: "Advanced SQL Querying",
    pic: advanced_sql,
    view: "",
  },
  {
    id: "M334r38",
    title: "Top Performer DataBuzz Power BI March Challenge",
    pic: top_performer,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "M4r38",
    title: "Runner Up Awards ",
    pic: runner_up,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "M38",
    title: "Top 5 Finalists October 2025",
    pic: top5_3,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "M02200",
    title: "Critical Thinking in the Age of AI",
    pic: critical_thinking,
    view: "",
  },
  {
    id: "M42I48",
    title: "Gen AI Essential",
    pic: gen_ai,
    view: "",
  },
  {
    id: "MI00",
    title: "Prompt Engineering Masterclass",
    pic: prompt_eng,
    view: "",
  },
  {
    id: "MI48",
    title: "Data Literacy Foundations",
    pic: data_literacy,
    view: "",
  },
  {
    id: "MI00",
    title: "Intro to Financial Modeling",
    pic: fin_model,
    view: "",
  },
  {
    id: "MI48",
    title: "Cloud Basics for Data Professional",
    pic: cloud_basics,
    view: "",
  },
  {
    id: "MM88",
    title: "Top 5 Finalists May 2025",
    pic: top5_2,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "Y88",
    title: "Top 5 Finalists March 2025",
    pic: top5,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "Y82",
    title: "StoryTeller Badge February 2025",
    pic: storyteller,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "M098",
    title: "SQL Advent Calender",
    pic: sql_advent_2,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "P0330",
    title: "Python Summer Party",
    pic: pythonsummer,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "P00",
    title: "Power BI Service",
    pic: powerbiservice,
    view: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
  },
  {
    id: "P012",
    title: "Python Foundations for Data Analysis",
    pic: python,
    view: "https://certificates.mavenanalytics.io/77a369ff-cbec-4704-bcdd-a911b3bc92ee#acc.aWmqMrnY",
  },
  {
    id: "T012",
    title: "MySQL Data Analysis",
    pic: mysql,
    view: "https://certificates.mavenanalytics.io/def6f191-3fbc-4812-b546-bb31681fc4fd#acc.X87mZ9qQ",
  },
  {
    id: "P0",
    title: "Thinking Like An Analyst",
    pic: thinkinglikeananalyst,
    view: "https://github.com/idowuemmao/Airline_Delay_Report",
  },
  {
    id: "P1",
    title: "Data and AI Ethics",
    pic: dataandaiethics,
    view: "https://github.com/idowuemmao/Merchandise_Sale_Report",
  },
  {
    id: "P2",
    title: "Cisco",
    pic: cisco,
    view: "https://github.com/idowuemmao/AdventureWorksDashboard",
  },
  {
    id: "P4",
    title: "SQL Basics",
    pic: sqlbasic,
    view: "https://github.com/idowuemmao/Regional-Sales-Dashboard",
  },
  {
    id: "P42",
    title: "SQL Intermediate",
    pic: sqlint,
    view: "https://github.com/idowuemmao/Regional-Sales-Dashboard",
  },
  {
    id: "P3",
    title: "Intermediate SQL",
    pic: intsql,
    view: "https://github.com/idowuemmao/KPI-Dashboard",
  },
  {
    id: "P5",
    title: "Introduction to Power BI",
    pic: introtopowerbi,
    view: "https://github.com/idowuemmao/Candy_Research_Report",
  },
  {
    id: "P6",
    title: "Introduction to SQL",
    pic: introtosql,
    view: "https://github.com/idowuemmao/Employee_Performance",
  },
  {
    id: "P7",
    title: "Indian Box Office ",
    pic: indiaboxoffice,
    view: "https://github.com/idowuemmao/Mavin-Halloween-Candy-Dashboard",
  },
];
export default AwardDB;
